import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Helmet, HelmetProvider } from "react-helmet-async";
import { Tooltip as ReactTooltip } from "react-tooltip";

import SocialMediaPopUp from "components/SocialMediaPopUp/SocialMediaPopUp";
import PopUpModel from "components/PopUpModel";
import UserProfileShareBtn from "pages/userProfile/shared/UserProfileShareBtn";
import FollowFollowingSection from "./FollowFollowingSection";
import ProfileDetails from "./ProfileDetails";
import QRPopUp from "components/qrPopUp/QRPopUp";
import ConnectTvBtn from "./ConnectTvBtn";
import ConnectTvPopUp from "components/ConnectTv/TvPopUp/ConnectTvPopUp";
import { FaCrown } from "react-icons/fa";
import BackdropImg from "../../../Assets/Images/backdrop.png";
import logoImage from "Assets/Images/placeholder.png";

function ProfileHeroSection({ user, isLoading, playlists }: any) {
  const baseUrl = window.location.origin;
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [follow, setFollow] = useState<boolean>(false);
  const [updatedUser, setUpdatedUser] = useState<any>(user);
  useEffect(() => {
    setUpdatedUser(user);
  }, [user]);
  const currentUrl = baseUrl + window.location.pathname;
  const [showModal, setShowModal] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [showTVModal, setShowTVModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openQRModal = () => {
    setShowQRModal(true);
  };

  const closeQRModal = () => {
    setShowQRModal(false);
  };

  const openConnectTvModel = () => {
    setShowTVModal(true);
  };

  const closeConnectTvModel = () => {
    setShowTVModal(false);
  };

  const isPlusUser = user?.is_subscribed;

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta name="title" content={user?.name} />
          <meta name="description" content={user?.bio} />

          <meta name="twitter:title" content={user?.name} />
          <meta name="twitter:description" content={user?.bio} />
          <meta name="twitter:image" content={user?.artwork_url} />

          <meta property="og:title" content={user?.name} />
          <meta property="og:description" content={user?.bio} />
          <meta property="og:image:secure_url" content={user?.artwork_url} />
        </Helmet>
      </HelmetProvider>
      <div className="w-full max-lg:h-[20vh] max-sm:h-[80vh]">
        <div className="relative mx-auto h-[34vh] overflow-hidden rounded-2xl bg-black shadow-lg max-lg:h-[20vh] max-sm:h-full max-sm:rounded-none">
          {/* desktop backdrop */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat max-sm:hidden"
            style={{ backgroundImage: `url(${BackdropImg})` }}
          />
          {/* mobile: blurred placeholder */}
          <div
            className="absolute inset-0 scale-110 bg-cover bg-center bg-no-repeat blur-2xl sm:hidden"
            style={{ backgroundImage: `url(${logoImage})` }}
          />

          {/* cinematic overlays: bottom blend + (plus) red glow + page fade */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black via-black/45 to-black/10" />
          {isPlusUser && (
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#F50537]/45 via-transparent to-transparent" />
          )}

          <div className="relative flex h-full flex-col justify-between px-5 py-6">
            <div className="flex w-full items-center justify-end gap-3">
              {isPlusUser && (
                <span className="mr-auto inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-black/40 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white backdrop-blur-md">
                  <FaCrown className="text-[12px] text-[#F50537]" />
                  Plus Member
                </span>
              )}
              <UserProfileShareBtn openModal={openModal} />
              {/* <UserProfileQRBtn openQRModal={openQRModal} user={user} /> */}
              <ConnectTvBtn openConnectTvModel={openConnectTvModel} />
            </div>
            {/* bottom: mobile profile details + desktop stats (bottom-right) */}
            <div className="flex items-end justify-end">
              <div className="flex-1 sm:hidden">
                <ProfileDetails
                  user={user}
                  updatedUser={updatedUser}
                  setUpdatedUser={setUpdatedUser}
                  follow={follow}
                  setFollow={setFollow}
                  playlists={playlists}
                />
              </div>
              <FollowFollowingSection
                user={user}
                className="relative z-20 justify-end max-sm:hidden"
              />
            </div>
          </div>

          {showModal && (
            <div className="z-50">
              <PopUpModel
                isOpen={showModal}
                onClose={closeModal}
                width={"480px"}
                isClosedWhenClickOutside={true}
              >
                <SocialMediaPopUp shareUrl={currentUrl} />
              </PopUpModel>
            </div>
          )}

          {showQRModal && (
            <div className="z-50">
              <PopUpModel
                isOpen={showQRModal}
                onClose={closeQRModal}
                width={"800px"}
                isClosedWhenClickOutside={true}
              >
                <QRPopUp />
              </PopUpModel>
            </div>
          )}

          {showTVModal && (
            <PopUpModel
              isOpen={showTVModal}
              onClose={closeConnectTvModel}
              width={"800px"}
              isClosedWhenClickOutside={true}
            >
              <ConnectTvPopUp />
            </PopUpModel>
          )}
        </div>

        <ReactTooltip
          id="copy-profile-link"
          place="bottom"
          content="Copy to clipboard!"
        />
      </div>

      {/* profile details */}
      <div className="max-sm:hidden">
        <ProfileDetails
          user={user}
          updatedUser={updatedUser}
          setUpdatedUser={setUpdatedUser}
          follow={follow}
          setFollow={setFollow}
        />
      </div>
    </>
  );
}

export default ProfileHeroSection;
